import BuildOutlinedIcon from '@mui/icons-material/BuildOutlined';
import WhatsAppIcon from '@mui/icons-material/WhatsApp';
import { Button, Card, CardContent, Stack, Typography } from '@mui/material';
import { buildWhatsAppUrl, repairInquiryMessage } from '@/features/operations/whatsapp';
import { HomeSection } from './HomeSection';

type RepairsSectionProps = {
  /** `undefined` while it loads, `null` when PhoneTec has no number or it cannot be read. */
  whatsappNumber: string | null | undefined;
};

/**
 * Repairs on the landing. The repairs module is MIG-9 to MIG-12 (#270); until it exists the
 * section sends the visitor to PhoneTec's WhatsApp, and without a number it points to a store.
 */
export function RepairsSection({ whatsappNumber }: RepairsSectionProps) {
  return (
    <HomeSection
      id="repairs"
      eyebrow="REPARACIONES"
      title="También reparamos tu celular."
      description="Además de vender usados certificados, en PhoneTec reparamos celulares."
    >
      <Card>
        <CardContent>
          <Stack
            direction={{ xs: 'column', sm: 'row' }}
            spacing={2}
            alignItems={{ xs: 'flex-start', sm: 'center' }}
          >
            <BuildOutlinedIcon color="secondary" />
            <Stack spacing={0.5} sx={{ flex: 1 }}>
              <Typography variant="body1">
                Contanos qué le pasa a tu equipo y te decimos cómo seguimos.
              </Typography>
              {whatsappNumber === null ? (
                <Typography variant="body2" color="text.secondary">
                  Acercate a un local PhoneTec para consultarlo.
                </Typography>
              ) : null}
            </Stack>
            {whatsappNumber ? (
              <Button
                href={buildWhatsAppUrl(whatsappNumber, repairInquiryMessage)}
                target="_blank"
                rel="noopener noreferrer"
                variant="outlined"
                color="inherit"
                startIcon={<WhatsAppIcon />}
              >
                Consultar por WhatsApp
              </Button>
            ) : null}
          </Stack>
        </CardContent>
      </Card>
    </HomeSection>
  );
}
